import React, { useState, useRef, useEffect } from "react";
import {
  reminderTimeDropdownOptions,
  validateDateWithWorkingHoursTimeZone,
} from "../../../utils";
import Tippy from "@tippyjs/react";
import { getDateTimeWithFormat } from "../../../utils";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import {
  Collaborator,
  Customer,
} from "../../../constant/AuthenticationConstant";
import moment from "moment";
import { useSelector } from "react-redux";
import { useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";
import {
  status_fill_Color1,
  status_fill_Color2,
  statusOuterColor,
} from "../Helpers";

function DragAndDropTodoItem({
  assignmentFormik,
  arrayHelpersToDo,
  index,
  i,
  todoList,
  element,
  deptList,
  workingHours,
  activeTodo,
  setActiveTodo,
}) {
  const [draggingState, setDraggingState] = useState();
  const [assignmentActivityList, setAssignmentActivityList] = useState([]);

  // Ref
  const dropRef = useRef(null);
  const dragRef = useRef(null);

  //Redux
  const { deptWithUserAndCollaborators } = useSelector(
    (state) => state.department
  );

  const getStatusStyles = (status) => {
    switch (status) {
      case "completed":
      case "completed with delay":
        return {
          className:
            "w-4 h-4 border-3 rounded-full border-[--bg-color-500] bg-[--bg-color-500]",
          innerDiv: null,
          tooltipContent: "completed",
        };
      case "pending":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500]",
          innerDiv: null,
        };
      case "in progress":
        return {
          className:
            "w-4 h-4 border-3 rounded-full border-[--bg-color-500] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full bg-[--bg-color-500] rounded-l-full border-0"></div>
          ),
        };
      case "overdue":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313]",
          innerDiv: null,
          tooltipContent: "overdue",
        };
      case "overdue-inprogress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full rounded-l-full border-0 bg-[#D31313]"></div>
          ),
          tooltipContent: "overdue-inprogress",
        };
      default:
        return {
          className: "w-4 h-4 border-3 rounded-full border-grey-500",
          innerDiv: null,
        };
    }
  };

  // const renderStatus = (status) => {
  //   const { className, innerDiv, tooltipContent } = getStatusStyles(status);

  //   return status ? (
  //     <Tippy content={tooltipContent ?? status}>
  //       <div className={className}>{innerDiv}</div>
  //     </Tippy>
  //   ) : (
  //     <div className={className}>{innerDiv}</div>
  //   );
  // };

  const show_assigned_team_or_users = (index, i) => {
    if (
      assignmentFormik?.values?.workflows[index]?.assignments[i]?.userSelect
    ) {
      return assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.userSelect?.label;
    } else if (
      assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.departmentSelect
    ) {
      return assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.departmentSelect?.label;
    } else {
      return null;
    }
  };

  // const setReminderTime = (value, index, i) => {
  //   const reminderDateTime = moment(
  //     assignmentFormik.values.workflows[index].assignments[i].estimated_time
  //   )
  //     .subtract(value, "hours")
  //     .format("YYYY-MM-DD HH:mm");

  //   assignmentFormik.setFieldValue(
  //     `workflows[${index}].assignments[${i}].reminder_time`,
  //     reminderDateTime
  //   );
  // };

  // const getUsersOptions = (selectedTeams) => {
  //   let list = [];
  //   if (["collaborator", "customer"].includes(selectedTeams.value)) {
  //     list =
  //       deptWithUserAndCollaborators?.collaborators.filter(
  //         (item) => item.type === selectedTeams.value
  //       ) || [];
  //   } else {
  //     list =
  //       deptWithUserAndCollaborators?.departments.find(
  //         (item) => item.value === selectedTeams.value
  //       )?.user_departments || [];
  //   }
  //   // if (selectedTeams) {
  //   //   if (
  //   //     selectedTeams.value === Collaborator ||
  //   //     selectedTeams.value === Customer
  //   //   ) {
  //   //     return customerAndCollaboratorOptions.filter(
  //   //       (item) => item.type === selectedTeams?.value
  //   //     );
  //   //   } else {
  //   //     const filteredData = usersOptions.filter((data) => {
  //   //       const user = department_wise_user.find(
  //   //         (user) => user?.id === data?.value
  //   //       );

  //   //       return user?.departments.some((item) => {
  //   //         return item?.id ? item?.id === selectedTeams?.value : false;
  //   //       });
  //   //     });
  //   //     return filteredData;
  //   //   }
  //   // }
  //   return list;
  // };

  const moveRow = (dragIndex, hoverIndex) => {
    const dragRecord =
      assignmentFormik.values.workflows[index].assignments[dragIndex];

    setAssignmentActivityList(
      update(assignmentFormik.values.workflows[index].assignments, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRecord],
        ],
      })
    );

    setDraggingState(dragIndex);
  };

  // Handle Dragging Item
  const [{ isDragging }, drag, preview] = useDrag({
    type: "item",
    item: { i },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Handle Dropped Item
  const [, drop] = useDrop({
    accept: "item",
    hover(item, monitor) {
      if (!dropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = i;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  preview(drop(dropRef));
  drag(dragRef);

  useEffect(() => {
    if (draggingState !== null && draggingState !== undefined) {
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments`,
        assignmentActivityList
      );
    }
  }, [draggingState]);

  const linkLoopActivityName = (link_todo_id) => {
    const todoName = todoList.find((item) => item.value === link_todo_id);
    return todoName ? todoName.label : "";
  };

  const addEta = (date, index, i, previous_date, flag = false) => {
    const configurationSettingMappingData =
      assignmentFormik.values.workflows[index].assignments;

    if (date) {
      if (!flag) {
        if (workingHours && workingHours?.is_working_hours) {
          const todoFind = configurationSettingMappingData.find(
            (item) =>
              item.activity_id ===
              assignmentFormik.values.workflows[index].assignments[i]
                .activity_id
          );
          if (todoFind && (todoFind.dept_timzone || todoFind.user_timzone)) {
            const timezone = todoFind?.user_timzone
              ? todoFind.user_timzone
              : todoFind.dept_timzone;
            if (timezone) {
              const calculated_date = validateDateWithWorkingHoursTimeZone(
                timezone,
                workingHours,
                previous_date,
                date
              );
              if (calculated_date !== null) {
                date = calculated_date;
              }
            }
          }
        }
      }

      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].estimated_time`,
        new Date(date).toISOString()
      );

      if (
        assignmentFormik.values.workflows[index].assignments[i].reminder_time &&
        moment(date).isBefore(
          assignmentFormik.values.workflows[index].assignments[i].reminder_time
        )
      ) {
        assignmentFormik.setFieldValue(
          `workflows[${index}].assignments[${i}].reminder_time`,
          null
        );
        assignmentFormik.setFieldValue(
          `workflows[${index}].assignments[${i}].reminderTimeDropdownVal`,
          ""
        );
      }
    } else {
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].reminder_time`,
        null
      );
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].reminderTimeDropdownVal`,
        ""
      );
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].estimated_time`,
        null
      );
    }

    for (
      let indexEst = 0;
      indexEst < configurationSettingMappingData.length;
      indexEst++
    ) {
      if (
        configurationSettingMappingData[indexEst].link_activity ===
        assignmentFormik.values.workflows[index].assignments[i].activity_id
      ) {
        const getIndex = assignmentFormik.values.workflows[
          index
        ].assignments.findIndex(
          (item) =>
            item.activity_id ===
            configurationSettingMappingData[indexEst].activity_id
        );

        const eta = moment(date).add(
          configurationSettingMappingData[indexEst].duration,
          "hours"
        );
        // .toDate();

        // assignmentFormik.setFieldValue(
        //   `workflows[${index}].assignments[${getIndex}].estimated_time`,
        //   new Date(eta).toISOString()
        // );

        addEta(eta, index, getIndex, date);
      }
    }
  };

  const currentDate = moment();
  // Creating function for default minimum date in estimater date.
  const getMinimumDate = (date) => {
    const isLessThanCurrentDate = moment(date).isBefore(currentDate);
    const isGreaterThanCurrentDate = moment(date).isAfter(currentDate);
    const equalToCurrentDate = moment(date).isSame(currentDate, "day");

    if (isLessThanCurrentDate) {
      return date;
    } else if (isGreaterThanCurrentDate) {
      return new Date();
    } else if (equalToCurrentDate) {
      return new Date();
    }
  };

  const handleTodoClick = () => {
    if (index === activeTodo?.index && i === activeTodo?.i) {
      setActiveTodo(null);
    } else {
      setActiveTodo({
        index: index,
        i: i
      });
    }
  };

  return (
    <div className="w-full" ref={dropRef}>
      <div className="w-full cursor-pointer space-y-2">
        <div className="w-full flex flex-row items-center space-x-3">
          <div>
            <span
              ref={dragRef}
              onMouseLeave={(e) => {
                setDraggingState(null);
              }}
              className="fa-regular fa-bars text-[#9CA3AF] text-sm cursor-pointer"
            ></span>
          </div>

          <div
            className="w-full flex items-start space-x-2 relative"
            onClick={(e) => {
              e.stopPropagation();
              handleTodoClick(
                assignmentFormik?.values?.workflows[index]?.assignments[i]
              );
            }}
          >
            <div
              className={`rounded-md ${
                index === activeTodo?.index && i === activeTodo?.i
                  ? "bg-[--bg-color-500]"
                  : "bg-[--bg-color-50]"
              }  grow w-full p-2 flex items-center space-x-2`}
            >
              <div className="w-full space-y-3">
                <div className="w-full flex flex-row items-center justify-between">
                  <div
                    className={`text-sm font-semibold ${
                      index === activeTodo?.index && i === activeTodo?.i
                        ? "text-white"
                        : "text-[#535860]"
                    } leading-[100%] tracking-tight`}
                  >
                    {assignmentFormik.values.workflows[index].assignments[i]
                      ?.activity_id
                      ? todoList.find(
                          (todoItem) =>
                            todoItem.value ===
                            assignmentFormik.values?.workflows[index]
                              ?.assignments[i]?.activity_id
                        )?.label
                      : "To Do Name"}
                  </div>
                  <div
                    className={`w-4 h-4 border-3 ${statusOuterColor(
                      "tentative"
                    )} rounded-full flex`}
                  >
                    <div
                      className={`flex-1 ${status_fill_Color1("tentative")}`}
                    ></div>
                    <div
                      className={`flex-1 ${status_fill_Color2("tentative")}`}
                    ></div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <p
                    className={`text-[13px] font-semibold ${
                      index === activeTodo?.index && i === activeTodo?.i
                        ? "text-white"
                        : "text-[--bg-color-500]"
                    } leading-[100%] tracking-tight`}
                  >
                    {show_assigned_team_or_users(index, i) === null ? (
                      <>
                        <i
                          className={`fa-regular fa-triangle-exclamation ${
                            index === activeTodo?.index && i === activeTodo?.i
                              ? "text-white"
                              : "text-[#CC7919]"
                          } `}
                        ></i>
                        <span
                          className={`pl-2 font-inter font-medium text-[13px] ${
                            index === activeTodo?.index && i === activeTodo?.i
                              ? "text-white"
                              : "text-[#EB5757]"
                          } text-[#EB5757]`}
                        >
                          No user assigned
                        </span>
                      </>
                    ) : (
                      `${show_assigned_team_or_users(index, i)}`
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`w-full pl-6 ${
            index === activeTodo?.index && i === activeTodo?.i
              ? "block"
              : "hidden"
          }`}
        >
          <button
            className="w-full btn-sm bg-white border-slate-200 hover:border-slate-300 font-inter font-semibold text-[13px] text-[--bg-color-500] cursor-pointer"
            onClick={(event) => {
              event.preventDefault();
              arrayHelpersToDo.insert(i + 1, {
                activity_id: null,
                department_id: null,
                user_id: null,
                sequence: i + 2,
                is_mandatory: false,
                link_activity: null,
                loop_activity: null,
                duration: 0,
                collaborator_id: null,
                estimated_time: null,
                reminder_time: null,
                departmentSelect: "",
                userSelect: "",
                reminderTimeDropdownVal: "",
                status: "pending",
              });
            }}
          >
            + Add To Do
          </button>
        </div>
      </div>
    </div>
  );
}

export default DragAndDropTodoItem;
